getEligibleEffects